import template from './refineColumns.html';
import mori from 'mori';
import stateGo from 'redux-ui-router/lib/state-go';
import { appDefault } from '../../config/config';
import {
  mapToArray,
} from './children/util';
import { buildRowProperties } from '../../util/sorters/util';
import iterateOverChildNodes from './children/iterateOverChildNodes';
import selectorEvents from './children/events';
import slugify from '../../util/slugify';
import { escapeHTML } from '../../util/util';

export default function() {
  return {
    scope: {
      columns: '=',
      context: '=',
    },
    templateUrl: template,
    link: Link,
    controller: Controller,
    controllerAs: 'vm',
    bindToController: true,
  };
}

Controller.$inject = ['$scope', '$ngRedux'];
function Controller($scope, $ngRedux) {
  const disconnect = $ngRedux.connect((state) => {
    return {
      router: state.router,
      sheet: state.data,
      selectedRows: state.router.currentParams.selectedRows,
      getRows: () => state.router.currentParams.selectedRows,
    };
  }, (dispatch) => ({ dispatch }))(this);
  $scope.$on('$destroy', disconnect);

  // Custom title for the columns
  this.title = this.context ? this.context : ['Locations', 'States', 'State'];

  const isGeoMulti = mori.getIn(
    this.sheet.config,
    ['globalRules', 'Geomulti'],
    false
  );

  this.treeContextSlug = slugify(this.title[1]);
  const treeContext =
    isGeoMulti ? this.columns.nested[this.treeContextSlug] : {};

  this.geoMultiChildren = isGeoMulti ?
    Object.keys(treeContext.children)
      .map(mapToArray(treeContext.children))
      .sort(({ label: a }, { label: b }) => a.localeCompare(b)) : [];

  $scope.$watch(
    () => this.router.currentParams.activeTab,
    (newVal) => {
      this.isGeoMultiMap = newVal === 'map' && isGeoMulti;
      const selectedRows = this.selectedRows || {};
      if (!this.isGeoMultiMap) {
        return;
      }

      // Set the initial multigeoSelection.
      // Get the selected rows, then the treeContextSlug
      // Else, just go with an empty object.
      // Failing that, default to the first key in the children array
      this.multigeoSelection = Object.keys(
        selectedRows[this.treeContextSlug] || {}
      ).sort()[0] || this.geoMultiChildren[0].key;

      this.selectGeoMultiMap(this.multigeoSelection);
    }
  );

  this.selectGeoMultiMap = (key) => {
    const parentSlug = `${this.treeContextSlug}--${key}`;
    const checked = true;
    const allCheckbox =
      document.querySelector(`input[id=${parentSlug}-all]`) || {};
    const allCheckboxLabel =
      document.querySelector(`label[for=${parentSlug}-all]`) || {};
    // Clear all selected checkboxes
    document.dispatchEvent(new Event('clearAll'));

    $ngRedux.dispatch(stateGo('datacenter.main', {
      selectedRows: {
        [this.treeContextSlug]: { [key]: { all: {} } },
      },
    }));

    allCheckbox.checked = true;
    allCheckboxLabel.innerHTML = escapeHTML(dcStrings.unselectAll);

    const event = new CustomEvent('selectAll', {
      detail: {
        parentSlug,
        checked,
        wrapups: [],
      },
    });
    document.dispatchEvent(event);
  };
}

function Link(scope, element/* , attr */) {
  // Use columnSelector/columnSelectorAll
  // @TODO make sure to sort the rows...
  const unregister = scope.$watchCollection('vm', (vm) => {
    if (typeof vm.columns === 'undefined') {
      return;
    }
    unregister(); // Stop watching we only want to do this once

    const isMedicare = mori.getIn(
      scope.vm.sheet.config,
      ['globalRules', 'medicare'],
      false
    );

    if (vm.columns.wrapups) {
      iterateOverChildNodes({
        container: element[0].querySelector('#main-geo p'),
        map: scope.vm.columns.wrapups,
        selectedRows: scope.vm.getRows(), // Currently selected rows
        parentSlug: 'wrapups',
        sortMethod: ({ label: a }, { label: b }) =>
          appDefault.wrapupOrder.indexOf(b) - appDefault.wrapupOrder.indexOf(a),
        events: selectorEvents(scope.vm.dispatch, scope.vm.getRows),
      });
    }
    if (vm.columns.nested) {
      iterateOverChildNodes({
        container: element[0].querySelector('#main-subgeo'),
        map: Object.keys(scope.vm.columns.nested)
          .map(mapToArray(scope.vm.columns.nested))
          .sort(({ key: a }, { key: b }) =>
            appDefault.countyOrder.indexOf(a.toLowerCase()) -
              appDefault.countyOrder.indexOf(b.toLowerCase())
          ),
        parentSlug: '',
        selectedRows: scope.vm.getRows(), // Currently selected rows
        wrapups: vm.columns.wrapups,
        sortMethod: ({ label: a }, { label: b }) => {
          const aProps = buildRowProperties(a);
          const bProps = buildRowProperties(b);
          // For special (numbered) geos, sort by the numerical value in the characteristic
          if (aProps.isSpecialGeo && bProps.isSpecialGeo) {
            const anum = parseInt(a.replace(/^\D+/g, ''), 10);
            const bnum = parseInt(b.replace(/^\D+/g, ''), 10);

            return anum - bnum;
          }

          return a.localeCompare(b);
        }, // A-Z order
        events: selectorEvents(
          scope.vm.dispatch, scope.vm.getRows, vm.columns.nested
        ),
        isMedicare,
      });
    }
  });
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/index.js
 **/